import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IUserActionResult } from '../types/IUserActionResult';

export interface ICreateLocalUserParams {
  username: string;           // name for new user; required, not empty; expected to be unique on server
  displayName: string;        // display or friendly name; required, not empty
  email: string;              // user email; not required
  encryptedPassword: string;  // password; required; encrypted with public key obtained by generatePublicKey
  keyId: string;              // id of public key used to encrypt password; required
  identityPoolName?: string;    // name of the identity pool that will be used as a login mechanism for this user. Null if using the default pool.
  admin?: boolean;            // true to make the new user a server admin (optional, mutually exclusive with 'siteRole')
  siteRole?: string;          // site role for new user (optional, mutually exclusive with 'admin')
  identifier?: string;        // Optional identifier to be used as alternative way to login  
}

export class CreateLocalUserRequest extends Request<ICreateLocalUserParams, IUserActionResult> {
  constructor(params: ICreateLocalUserParams) {
    super('createLocalUser', params);
  }
}
